/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum Version {
  V1,
  V2,
}

export type VersionArgs = Version;

export function getVersionEncoder(): FixedSizeEncoder<VersionArgs> {
  return getEnumEncoder(Version);
}

export function getVersionDecoder(): FixedSizeDecoder<Version> {
  return getEnumDecoder(Version);
}

export function getVersionCodec(): FixedSizeCodec<VersionArgs, Version> {
  return combineCodec(getVersionEncoder(), getVersionDecoder());
}
